import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

/**
 * Ported from pitstop-ui/src/components/EForm/FormField/cell-file-upload.jsx
 *
 * Read-only display only — shows the list of uploaded filenames from payload.
 *
 * Stripped:
 *   - react-dropzone (upload concerns, not needed for display)
 *   - etr-file-upload-Icon-Badge.svg (not in submittals-ui/assets/svgs)
 *   - feature-verifier / featureConstant, Toast2, remove-file handler
 *   - updatePayload, validateSchema (write path)
 */

const CellFileUploadComponent = ({
  isReadOnly,
  payload,
  parentProps,
  inputProps,
  setInputProps,
  getFieldValue,
  defaultFileLists = [],
}) => {
  const [fileLists, setFileLists] = useState(defaultFileLists)

  useEffect(() => {
    const attachmentsData = getFieldValue(payload, parentProps)

    setInputProps({
      ...inputProps,
      disabled: isReadOnly,
      value: attachmentsData,
    })

    if (attachmentsData?.attachments) {
      setFileLists(attachmentsData.attachments)
    }
  }, [payload])

  if (!fileLists?.length) {
    return <div className="eform-file-upload-empty">No attachments</div>
  }

  return (
    <div className="flex flex-wrap">
      {fileLists.map(
        (file, index) =>
          file?.name && (
            <div
              className="flex justify-between items-center w-[320px] mt-3 p-4 border border-grey-90 rounded-[5px] odd:mr-2 [&_.tooltip]:mt-1 [&_.tooltip]:cursor-pointer"
              key={index}
            >
              <div className="w-[200px] flex justify-between items-center px-[6px]">
                <div className="type-body-1 break-all line-clamp-2">{file.name}</div>
              </div>
            </div>
          )
      )}
    </div>
  )
}

CellFileUploadComponent.propTypes = {
  schema: PropTypes.object,
  isReadOnly: PropTypes.bool,
  payload: PropTypes.object,
  parentProps: PropTypes.array,
  inputProps: PropTypes.object,
  setInputProps: PropTypes.func,
  getFieldValue: PropTypes.func,
  defaultFileLists: PropTypes.array,
}

export default CellFileUploadComponent
